import "./ProfileUserInformationEdit.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import ProfileUserInformationEditComponentController from "./ProfileUserInformationEditComponentController";

export default class ProfileUserInformationEditComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = ProfileUserInformationEditComponentController;
        this.templateUrl =
            "/App/Modules/Auth/Components/Profile/UserInformation/EditForm/ProfileUserInformationEdit.html";
    }
}

module("mmAuth").component("mmProfileUserInformationEdit", new ProfileUserInformationEditComponent());
